/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import { Modal } from "flowbite-react";
import { Modal } from "react-bootstrap";
import { Remarkable } from "remarkable";
import useCommonApi from "../hooks/common-api";
import interact from "interactjs";
import { Tooltip } from "react-tooltip";

const TextEditor = ({
  blog_title,
  blog_image,
  contentEditableRef,
  createBlogFn,
  params,
  localStorageKey,
  isSourceView,
  setIsSourceView,
}) => {
  const [showTableModal, setShowTableModal] = useState(false);
  const [tableRows, setTableRows] = useState(2);
  const [tableColumns, setTableColumns] = useState(2);

  const openTableModal = () => setShowTableModal(true);
  const closeTableModal = () => setShowTableModal(false);

  const insertTable = () => {
    applyStyleSubFn("table", { rows: tableRows, columns: tableColumns });
    closeTableModal();
  };
  const { createBlog, updateBlog } = useCommonApi();
  const [fontSize, setFontSize] = useState("16px"); // Initial font size
  const imageRef = useRef(null);
  const [tooltip, setTooltip] = useState(null);
  const [typingTimer, setTypingTimer] = useState(null);
  const typingTimeout = 1000; // Set the timeout value in milliseconds (adjust as needed)
  const [cursorPosition, setCursorPosition] = useState(0);
  const [savedSelection, setSavedSelection] = useState(null);
  const [stringOutput, setstringOutput] = useState("");
  const [selectedFontSize, setSelectedFontSize] = useState("16px");
  const [history, setHistory] = useState([""]); // Initialize with an empty string
  const [currentStateIndex, setCurrentStateIndex] = useState(0);
  const saveSelection = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      setSavedSelection(range);
    }
  };
  // console.log(stringOutput, "string output");

  const restoreSelection = () => {
    if (savedSelection) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(savedSelection);
    }
  };

  const selectedContentSettings = JSON.parse(
    localStorage.getItem("selectedContentSettings")
  );
  const documentBodyRef = useRef(null);
  const [openModal, setopenModal] = useState(undefined);
  const [imageUrl, setimageUrl] = useState("");
  const [alttext, setalttext] = useState("");
  const navigate = useNavigate();
  const [rawFile, setrawFile] = useState(null);
  const [previewUrl, setpreviewUrl] = useState(null);
  const [displayChooseFile, setdisplayChooseFile] = useState(true);
  const [imageWH, setimageWH] = useState({
    width: "300",
    height: "300",
  });
  const [totalText, settotalText] = useState("");
  const [selectedContent, setSelectedContent] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [startIndex, setStartIndex] = useState("");
  const [endIndex, setEndIndex] = useState("");
  const [ws, setWs] = useState(null);
  const [loader, setloader] = useState(false);
  const [reWriteWords, setreWriteWords] = useState("");
  const [rewriting, setrewriting] = useState(false);
  const [rewritingClicked, setrewritingClicked] = useState(false);
  const uploadedImages = useRef([]);
  const [editorState, setEditorState] = useState("");
  const [undoStack, setUndoStack] = useState([]);
  const [redoStack, setRedoStack] = useState([]);
  const textAreaRef = useRef(null);
  const [linkToolbar, setLinkToolbar] = useState({
    show: false,
    value: "",
    position: { top: 0, left: 0 },
    applyLink: null,
    removeLink: null,
    edit: false,
  });
  const [activeFormats, setActiveFormats] = useState({
    bold: false,
    italic: false,
    underline: false,
    strikethrough: false,
    link: false,
  });
  const linkButtonRef = useRef(null);
  const linkInputRef = useRef(null);
  const toolbarRef = useRef(null);
  const openModalFn = () => {
    // Save the current cursor position
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      setSavedSelection(selection.getRangeAt(0).cloneRange());
    }
    setalttext("");
    setimageUrl("");
    setpreviewUrl(null);
    setrawFile(null);
    setdisplayChooseFile(true);

    // Open the modal
    setopenModal("dismissible");
  };
  // console.log(openModal, "open modal");
  // Example function of remarkable
  const getRemarkableText = () => {
    // return innerHTML;
    const md = new Remarkable();
    md.set({
      html: true,
      breaks: true,
      linkify: true,
      typographer: true,
      quotes: "“”‘’",
      xhtmlOut: true,
    });
    // Example
    // const stringOutput = `# Hello world h1! \n\n  ## H2 \n\n **bold** \n\n *italic*\n\n > This is a blockquote\n\n ![alt text](https://github.com/adam-p/markdown-here/raw/master/src/common/images/icon48.png "Logo Title Text 1")\n\n [This is a link](https://www.google.com/)\n\n* This is a list item`;
    // stringIn=stringIn.replaceAll("\n/g", "<br/>");
    const html = md.render(stringOutput || "");
    // console.log(html, "html");
    return html;
  };
  const [htmlContent, setHtmlContent] = useState("");

  // console.log(imageWH, "image wh");
  const savedSelectionRef = useRef(null); // Store selection persistently
  const removeHighlight = () => {
    document.querySelectorAll(".temporary-highlight").forEach((el) => {
      const parent = el.parentNode;
      while (el.firstChild) parent.insertBefore(el.firstChild, el);
      parent.removeChild(el);
    });
    // removeEmptyTags();// Remove empty tags after removing highlight//specially written for links
  };
  const applyStyleSubFn = async (
    style,
    value = null,
    image_id = null,
    createLink = ""
  ) => {
    const selection = window.getSelection();
    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0);
    const selectedText = range.toString();
    if (
      selection &&
      selection.rangeCount > 0 &&
      contentEditableRef.current.contains(
        selection.getRangeAt(0).commonAncestorContainer
      )
    ) {
      if (style === "createLink") {
        const closestA =
          range.commonAncestorContainer.parentElement.closest("a");
        const existingLink = (() => {
          const range = selection.getRangeAt(0);
          const commonAncestor = range.commonAncestorContainer;

          // Check if selection is inside or contains a link
          const isInsideLink =
            commonAncestor.nodeType === Node.TEXT_NODE
              ? commonAncestor.parentElement.closest("a")
              : commonAncestor.closest("a");

          // If direct link found, return it
          if (isInsideLink) return isInsideLink;

          // Check if selection contains any links
          const tempDiv = document.createElement("div");
          tempDiv.appendChild(range.cloneContents());
          const linksInSelection = tempDiv.getElementsByTagName("a");

          // Return first link found in selection if any
          return linksInSelection.length > 0 ? linksInSelection[0] : null;
        })();
        console.log(existingLink, "existing link");
        // return;

        // // Wrap selected text in a temporary span to highlight
        // const tempSpan = document.createElement("span");
        // tempSpan.style.backgroundColor = "lightblue";
        // tempSpan.classList.add("temporary-highlight");
        // tempSpan.appendChild(document.createTextNode(selectedText));
        // range.deleteContents();
        // range.insertNode(tempSpan);

        // const range = selection.getRangeAt(0);
        const tempSpan = document.createElement("span");
        tempSpan.style.backgroundColor = "lightblue";
        tempSpan.classList.add("temporary-highlight");

        // Clone the range contents with all formatting
        const clonedContents = range.cloneContents();
        tempSpan.appendChild(clonedContents);

        // Insert the highlighted content
        range.deleteContents();
        range.insertNode(tempSpan);

        // Save selection
        savedSelectionRef.current = range.cloneRange();
        const rect = range.getBoundingClientRect();
        const contentEditableRect =
          contentEditableRef?.current?.getBoundingClientRect();
        let left = rect?.left;
        if (rect?.left + 306 > contentEditableRect?.right) {
          left = contentEditableRect?.right - 306;
        }
        // const rect = linkButtonRef?.current?.getBoundingClientRect();
        console.log(existingLink, closestA, "existing link");
        setLinkToolbar({
          show: true,
          value: existingLink ? existingLink.href : "",
          position: {
            top: rect?.bottom, // Position 5px below selection
            left: left, // Position at the left edge of the selection
          },
          edit: createLink !== "direct" ? true : false,
          applyLink: (url) => {
            if (savedSelectionRef.current) {
              const sel = window.getSelection();
              sel.removeAllRanges();
              sel.addRange(savedSelectionRef.current);
            }
            removeHighlight(); // Remove highlight after applying link
            document.execCommand("createLink", false, url);
            setLinkToolbar({
              show: false,
              value: "",
              position: {},
              applyLink: null,
              removeLink: null,
              edit: false,
            });
            if (window.getSelection) {
              window.getSelection().removeAllRanges(); // For modern browsers
              setActiveFormats({
                bold: false,
                italic: false,
                underline: false,
                strikethrough: false,
                link: false,
                heading: null,
                paragraph: false,
                unorderedList: false,
                orderedList: false,
                alignment: null,
              });
            }
          },
          removeLink: () => {
            if (savedSelectionRef.current) {
              const sel = window.getSelection();
              sel.removeAllRanges();
              sel.addRange(savedSelectionRef.current);
            }
            document.execCommand("unlink", false, null);
            removeHighlight(); // Remove highlight after applying link
            setLinkToolbar({
              show: false,
              value: "",
              position: {},
              applyLink: null,
              removeLink: null,
              edit: false,
            });
            setActiveFormats({
              bold: false,
              italic: false,
              underline: false,
              strikethrough: false,
              link: false,
              heading: null,
              paragraph: false,
              unorderedList: false,
              orderedList: false,
              alignment: null,
            });
          },
        });

        return;
      }
      const wrapSelectedText = (element) => {
        element.appendChild(document.createTextNode(selectedText));
        range.deleteContents();
        range.insertNode(element);
      };

      const createStyledElement = (tag, styles = {}, classNames = []) => {
        let element;
        if (tag == "font") {
          element = document.createElement("span");
        } else {
          element = document.createElement(tag);
        }
        let tags = ["h1", "h2", "h3", "h4", "h5", "h6", "font"];
        if (tags.includes(tag)) {
          // console.log("came in h1");
          Object.assign(element.style, { ...styles });
        } else {
          // console.log("came in other");
          Object.assign(element.style, { ...styles, fontSize: "16px" }); // Ensure base font size
        }
        element.className = classNames.join(" ");
        return element;
      };

      const applyListStyle = (listType, classNames = []) => {
        const listElement = document.createElement(listType);
        if (classNames.length > 0) {
          listElement.className = classNames.join(" ");
        }
        const listItem = document.createElement("li");
        listItem.appendChild(document.createTextNode(selectedText));
        listElement.appendChild(listItem);
        range.deleteContents();
        range.insertNode(listElement);
      };
      switch (style) {
        case "bold":
        case "italic":
        case "underline":
        case "strikeThrough":
        case "subscript":
        case "superscript":
        case "justifyLeft":
        case "justifyCenter":
        case "justifyRight":
        case "justifyFull":
        case "insertUnorderedList":
        case "insertOrderedList":
          document.execCommand(style, false, null);
          break;
        case "formatBlock":
          document.execCommand("formatBlock", false, value);
          break;
        case "table":
          const { rows, columns } = value;
          const table = document.createElement("table");
          table.style.margin = "0 auto"; // Center the table
          table.style.borderCollapse = "collapse";

          for (let i = 0; i < rows; i++) {
            const tr = document.createElement("tr");
            for (let j = 0; j < columns; j++) {
              const td = document.createElement("td");
              const div = document.createElement("div");
              div.className = "td-content";
              td.style.border = "2px solid #ccc";
              td.appendChild(div);
              tr.appendChild(td);
            }
            table.appendChild(tr);
          }

          range.deleteContents();
          range.insertNode(table);
          break;
        case "image":
          const range1 =
            selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
          const imgContainer = createStyledElement(
            "div",
            {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
            ["image-container"]
          );
          imgContainer.setAttribute("data-image-id", image_id);
          imgContainer.setAttribute("contenteditable", "false");

          const imgElement = createStyledElement("img", {
            width:
              imageWH.width?.trim() !== ""
                ? imageWH.width?.trim() + "px"
                : "300px",
            height:
              imageWH.height?.trim() !== ""
                ? imageWH.height?.trim() + "px"
                : "300px",
            objectFit: "fill",
          });
          imgElement.src = image_id;
          imgElement.alt = alttext;
          imgContainer.appendChild(imgElement);
          imgContainer.classList.add("group");

          range1.deleteContents();
          range1.insertNode(imgContainer);

          setimageUrl("");
          setrawFile(null);
          setpreviewUrl(null);
          setdisplayChooseFile(false);
          setTimeout(() => {
            setdisplayChooseFile(true);
          }, 10);
          setimageWH({
            width: "300",
            height: "300",
          });
          break;
        default:
          break;
      }
      if (style !== "bold" && style !== "italic" && style !== "underline") {
        handleContentChange({
          target: {
            innerHTML: contentEditableRef?.current?.innerHTML,
          },
        });
      }
    }

    contentEditableRef?.current?.focus();
    handleSelectionChange();
  };

  // console.log(uploadedImages, "uploaded images");
  const applyStyle = async (style, value = null) => {
    if (style == "image" && rawFile && previewUrl) {
      await uploadIconFn(style, value)?.data;
    } else {
      applyStyleSubFn(style, value, null);
    }
    setopenModal(undefined);
  };

  useEffect(() => {
    if (!rawFile) {
      setpreviewUrl(null);
      return;
    }
    const objectURL = URL.createObjectURL(rawFile);
    setpreviewUrl(objectURL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawFile]);
  useEffect(() => {
    documentBodyRef.current = document.body;
  }, []);

  const uploadIconFn = async (style, value) => {
    try {
      let formdata = new FormData();

      formdata.append("vsn_file", rawFile);

      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/upload/files/editorimage`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          jwt_token: localStorage.getItem("admin_user_token"),
        },
        timeout: 120000,
        data: formdata,
      });

      if (!response.data.error) {
        applyStyleSubFn(style, value, response.data.file_path);

        return {
          error: false,
          data: response.data.file_path,
        };
      } else {
        return {
          error: true,
          data: response.data.message,
        };
      }
    } catch (error) {
      console.log(error);
      return {
        error: true,
        data: error.message,
      };
    }
  };
  const deleteImage = async (dataImageId) => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/delete/upload_file`,
        method: "POST",
        headers: {
          jwt_token: localStorage.getItem("admin_user_token"),
        },
        timeout: 120000,
        data: {
          file_path: dataImageId,
        },
      });

      if (!response.data.error) {
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (toolbarRef.current && !toolbarRef.current.contains(event.target)) {
        setLinkToolbar((prev) => ({ ...prev, show: false }));
        if (window.getSelection().rangeCount > 0) {
          window.getSelection().removeAllRanges();
        }
        removeHighlight();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setLinkToolbar]);
  useEffect(() => {
    // Cleanup function to clear the timer when the component unmounts
    return () => {
      if (typingTimer) {
        clearTimeout(typingTimer);
      }
    };
  }, [typingTimer]);

  const handleImageDelete = (newData) => {
    const newImages = Array.from(newData.matchAll(/<img.*?src="(.*?)"/g)).map(
      (match) => match[1]
    );
    // console.log(newImages, "images");

    uploadedImages?.current?.forEach((oldImage) => {
      if (!newImages.includes(oldImage)) {
        deleteImage(oldImage, "editor");
      }
    });
  };
  // console.log(undoStack, "save state");
  const handleContentChange = (event) => {
    let updatedContent = event.target.innerHTML;
    handleImageDelete(contentEditableRef.current.innerHTML);
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = updatedContent;

    tempDiv.querySelectorAll(".temporary-highlight").forEach((span) => {
      const parent = span.parentNode;
      while (span.firstChild) {
        parent.insertBefore(span.firstChild, span);
      }
      parent.removeChild(span);
    });

    updatedContent = tempDiv.innerHTML;
    // Clear the previous timer
    if (typingTimer) {
      clearTimeout(typingTimer);
    }

    // Set a new timer to call the save API after typingTimeout milliseconds
    const newTypingTimer = setTimeout(() => {
      saveContentToApi(updatedContent);
    }, typingTimeout);

    setTypingTimer(newTypingTimer);
  };

  const saveContentToApi = (content) => {
    // Create a temporary element to hold the HTML
    let tempElement = document.createElement("div");
    tempElement.innerHTML = contentEditableRef.current.innerHTML;

    // Get all elements with class 'hover-buttons' and remove them
    let hoverButtons = tempElement.querySelectorAll(".hover-buttons");
    hoverButtons.forEach((button) => button.parentNode.removeChild(button));

    // Get the cleaned HTML
    let cleanedHTML = tempElement.innerHTML;

    // console.log(cleanedHTML);

    // createBlogFn(null,contentEditableRef.current.innerHTML);

    // if (content && content != "") {
    //   callUpdateToFileApi(selectedContentSettings, content);
    // }
  };
  useEffect(() => {
    if (!contentEditableRef.current) return;
    if (params?.id !== "new") {
      if (localStorageKey == "admin_selected_blog") {
        contentEditableRef.current.innerHTML = JSON.parse(
          localStorage.getItem("admin_selected_blog")
        )?.blog_content;
        // setstringOutput(
        //   JSON.parse(localStorage.getItem("admin_selected_blog"))?.blog_content
        // );
        setHtmlContent(
          JSON.parse(localStorage.getItem("admin_selected_blog"))?.blog_content
        );
      } else if (localStorageKey == "admin_selected_tool") {
        contentEditableRef.current.innerHTML = JSON.parse(
          localStorage.getItem("admin_selected_tool")
        )?.content;
        // setstringOutput(
        //   JSON.parse(localStorage.getItem("admin_selected_tool"))?.content
        // );
        setHtmlContent(
          JSON.parse(localStorage.getItem("admin_selected_tool"))?.content
        );
      }
    }
  }, [contentEditableRef]);
  const getFontSizeAtCursor = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const node =
        range.startContainer.nodeType === 3
          ? range.startContainer.parentNode
          : range.startContainer;
      return window.getComputedStyle(node).fontSize;
    }
    return null;
  };
  const handleKeyDown = (e) => {
    if (e.key === "Backspace" || e.key === "Delete" || e.key === "Enter") {
      // Store the images before deleting
      uploadedImages.current = Array.from(
        contentEditableRef.current.innerHTML.matchAll(/<img.*?src="(.*?)"/g)
      ).map((match) => match[1]);
      // updateTOC();
    }
  };

  const handleInput = (e) => {
    // console.log("changing...");
    const content = contentEditableRef?.current?.innerHTML;
    // Check if the content is empty
    if (content === "" || content === "<br>") {
      // If empty, wrap it in <p></p>
      contentEditableRef.current.innerHTML = "<p><br></p>";
    }
    handleContentChange(e);
  };
  // const handleSelectionChange = () => {
  //   if (contentEditableRef.current.contains(document.activeElement)) {
  //     const fontSize = getFontSizeAtCursor();
  //     // console.log(fontSize, "font size");
  //     if (fontSize) {
  //       setSelectedFontSize(fontSize);
  //     }
  //   }
  // };
  const handleSelectionChange = () => {
    const selection = window.getSelection();
    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0);
    let parentNode = range.commonAncestorContainer;

    // Traverse up to find the nearest block element
    while (parentNode && parentNode.nodeType !== 1) {
      parentNode = parentNode.parentNode;
    }

    const computedStyle = window.getComputedStyle(parentNode);
    if (parentNode.nodeName === "A") {
      // If no text is selected or selection is collapsed
      if (selection.toString().length === 0 || selection.isCollapsed) {
        // Create new range for the entire anchor tag
        const newRange = document.createRange();
        newRange.selectNode(parentNode);

        // Clear existing selection and add new range
        selection.removeAllRanges();
        selection.addRange(newRange);
      }
      console.log(selection, "selection", selection.toString());
      console.log(parentNode, "parent node");
      applyStyleSubFn("createLink", null, null, "direct");
    }

    setActiveFormats({
      bold:
        document.queryCommandState("bold") || computedStyle.fontWeight >= 600,
      italic:
        document.queryCommandState("italic") ||
        computedStyle.fontStyle === "italic",
      underline:
        document.queryCommandState("underline") ||
        computedStyle.textDecoration.includes("underline"),
      strikeThrough:
        document.queryCommandState("strikeThrough") ||
        computedStyle.textDecoration.includes("line-through"),
      link: parentNode.nodeName === "A",

      // Detect Headings
      heading: ["H1", "H2", "H3", "H4", "H5", "H6"].includes(
        parentNode.nodeName
      )
        ? parentNode.nodeName
        : null,
      paragraph: parentNode.nodeName === "P",

      // Detect Lists
      unorderedList: parentNode.nodeName === "UL",
      orderedList: parentNode.nodeName === "OL",

      // Detect Alignments
      alignment:
        computedStyle.textAlign === "left"
          ? "left"
          : computedStyle.textAlign === "center"
          ? "center"
          : computedStyle.textAlign === "right"
          ? "right"
          : computedStyle.textAlign === "justify"
          ? "justify"
          : null,
    });
  };

  const sourceView = () => {
    const updatedHtml = `${contentEditableRef?.current.innerHTML}`;
    setHtmlContent(updatedHtml);
    setIsSourceView(true);
  };
  const normalView = () => {
    setHtmlContent(textAreaRef?.current?.value);
    setIsSourceView(false);
  };

  useEffect(() => {
    if(isSourceView){
      if(!textAreaRef.current) return;
    }else{
      if(!contentEditableRef.current) return;
    }
    if (isSourceView && textAreaRef && textAreaRef?.current) {
      console.log("came to if");
      textAreaRef.current.focus();
      textAreaRef.current.value = htmlContent;
    } else {
      console.log("came to else");
      contentEditableRef.current.innerHTML = htmlContent;
      // setstringOutput(htmlContent);
    }
  }, [htmlContent, isSourceView, textAreaRef, contentEditableRef]);
  console.log(textAreaRef?.current?.value, "text area ref value");
  // Function to update the link toolbar position
  const updateLinkToolbarPosition = () => {
    if (linkToolbar.show && savedSelectionRef.current) {
      const rect = savedSelectionRef.current.getBoundingClientRect();
      const contentEditableRect =
        contentEditableRef?.current?.getBoundingClientRect();

      let left = rect?.left;
      if (rect?.left + 306 > contentEditableRect?.right) {
        left = contentEditableRect?.right - 306;
      }

      setLinkToolbar((prev) => ({
        ...prev,
        position: {
          top: rect.bottom,
          left: left,
        },
      }));
    }
  };

  useEffect(() => {
    const contentEditableElement = contentEditableRef.current;

    const handleMouseOver = (e) => {
      const imgContainer = e.target.closest(".image-container");
      if (imgContainer) {
        addHoverButtons(imgContainer);
      }
    };

    const createHoverButton = (innerHtml, positionClass, onClick) => {
      const button = document.createElement("div");
      button.className = positionClass;
      button.innerHTML = innerHtml;
      button.onclick = onClick;
      return button;
    };

    const addHoverButtons = (imgContainer) => {
      let hoverButtons = imgContainer.querySelector(".hover-buttons");
      if (!hoverButtons) {
        hoverButtons = document.createElement("div");
        hoverButtons.className = "hover-buttons";

        const closeBtn = createHoverButton("x", "close-btn", () => {
          const dataImageId = imgContainer.getAttribute("data-image-id");
          // console.log(dataImageId, "data image id");
          deleteImage(dataImageId);
          imgContainer.remove();
        });

        const topLeftBtn = createHoverButton("&#8593;", "top-left", () => {
          const newLine = document.createElement("div");
          newLine.innerHTML = "<br>";
          imgContainer.parentNode.insertBefore(newLine, imgContainer);
          const newRange = document.createRange();
          newRange.setStartBefore(imgContainer);
          newRange.setEndBefore(imgContainer);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(newRange);
        });

        const bottomRightBtn = createHoverButton(
          "&#8595;",
          "bottom-right",
          () => {
            const newLine = document.createElement("div");
            newLine.innerHTML = "<br>";
            imgContainer.parentNode.insertBefore(
              newLine,
              imgContainer.nextSibling
            );
            const newRange = document.createRange();
            newRange.setStartAfter(imgContainer);
            newRange.setEndAfter(imgContainer);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(newRange);
          }
        );

        const leftAlignBtn = createHoverButton("&#8592;", "left-align", () => {
          imgContainer.style.float = "left";
          imgContainer.style.marginRight = "10px";
          imgContainer.style.marginBottom = "10px";
        });

        const rightAlignBtn = createHoverButton(
          "&#8594;",
          "right-align",
          () => {
            imgContainer.style.float = "right";
            imgContainer.style.marginLeft = "10px";
            imgContainer.style.marginBottom = "10px";
          }
        );
        const centerAlignBtn = createHoverButton(
          "&#8645;",
          "center-align",
          () => {
            imgContainer.style.float = "none";
            imgContainer.style.margin = "10px auto";
            imgContainer.style.display = "block";
          }
        );
        const centerResizeBtn = createHoverButton("⤡", "center-resize", () => {
          const currentWidth = imgContainer.querySelector("img").style.width;
          const currentHeight = imgContainer.querySelector("img").style.height;

          const newWidth = prompt(
            "Enter new width in pixels:",
            currentWidth || "300px"
          );
          const newHeight = prompt(
            "Enter new height in pixels:",
            currentHeight || "300px"
          );

          if (newWidth && newHeight) {
            imgContainer.querySelector("img").style.width = newWidth;
            imgContainer.querySelector("img").style.height = newHeight;
          }
        });

        const altModifyBtn = createHoverButton("Alt", "alt-modify", () => {
          const currentAlt = imgContainer.querySelector("img").alt;
          const newAlt = prompt("Enter new alt text:", currentAlt || "");
          if (newAlt) {
            imgContainer.querySelector("img").alt = newAlt;
          }
        });

        hoverButtons.appendChild(closeBtn);
        hoverButtons.appendChild(topLeftBtn);
        hoverButtons.appendChild(bottomRightBtn);
        hoverButtons.appendChild(leftAlignBtn);
        hoverButtons.appendChild(rightAlignBtn);
        hoverButtons.appendChild(centerAlignBtn);
        hoverButtons.appendChild(centerResizeBtn);
        hoverButtons.appendChild(altModifyBtn);
        imgContainer.appendChild(hoverButtons);
      }
    };

    const attachHoverButtonListeners = () => {
      const imgContainers =
        contentEditableElement?.querySelectorAll(".image-container");
      imgContainers?.forEach((imgContainer) => {
        addHoverButtons(imgContainer);
      });
    };

    contentEditableElement?.addEventListener("mouseover", handleMouseOver);

    // Call attachHoverButtonListeners when the component mounts or innerHTML changes
    attachHoverButtonListeners();

    return () => {
      contentEditableElement?.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  useEffect(() => {
    const contentEditableElement = contentEditableRef.current;
    contentEditableElement?.addEventListener("keydown", handleKeyDown);
    contentEditableElement?.addEventListener("input", handleInput);
    contentEditableElement?.addEventListener(
      "selectionchange",
      handleSelectionChange
    );

    // Initialize the editor with a paragraph if empty
    if (contentEditableElement && contentEditableElement.innerHTML === "") {
      contentEditableElement.innerHTML = "<p><br></p>";
    }

    return () => {
      contentEditableElement?.removeEventListener("keydown", handleKeyDown);
      contentEditableElement?.removeEventListener("input", handleInput);
      contentEditableElement?.removeEventListener(
        "selectionchange",
        handleSelectionChange
      );
    };
  }, []);
  // Add scroll event listener
  useEffect(() => {
    if (linkToolbar.show) {
      window.addEventListener("scroll", updateLinkToolbarPosition, true);
      return () => {
        window.removeEventListener("scroll", updateLinkToolbarPosition, true);
      };
    }
  }, [linkToolbar.show]);
  // console.log(htmlContent, "html content");

  return (
    <>
      {/* <div
        className="toc-container"
        id="toc-container"
        style={{
          maxHeight: "100px",
          overflow: "auto",
          border: "1px solid #ccc",
          marginBottom: "10px",
        }}
      >
        <strong>Table of Contents</strong>
        <div id="toc-list"></div>
      </div> */}
      {/* <div>
        <div className="flex items-center gap-2 bg-[#F9F9F9] py-1 px-1">
          <div className="flex items-center gap-4 w-full border-r-2 border-[black] pr-[10px]">
            <button
              className="font-extrabold text-[22px]"
              onClick={() => applyStyle("bold", "bold")}
            >
              B
            </button>
            <button
              className="italic text-[22px]"
              onClick={() => applyStyle("italic", "italic")}
            >
              I
            </button>
            <button
              className="underline text-[22px]"
              onClick={() => applyStyle("underline", "underline")}
            >
              U
            </button>
            <div className="flex items-center gap-2 w-full">
              <label className="text-[22px]">Font</label>
              <select
                className="text-[16px]"
                value={selectedFontSize}
                onChange={(e) => {
                  const newSize = e.target.value;
                  setSelectedFontSize(newSize);
                  applyStyle("fontSize", newSize);
                }}
              >
                <option value="12px">12px</option>
                <option value="14px">14px</option>
                <option value="16px">16px</option>
                <option value="18px">18px</option>
                <option value="20px">20px</option>
                <option value="22px">22px</option>
                <option value="24px">24px</option>
              </select>
            </div>
          </div>
          <div className="flex items-center gap-4 w-full border-r-2 border-[black] pr-[10px]">
            <button
              className="font-extrabold text-[22px]"
              onClick={() => applyStyle("heading", "h1")}
            >
              H1
            </button>
            <button
              className="font-extrabold text-[22px]"
              onClick={() => applyStyle("heading", "h2")}
            >
              H2
            </button>
            <button
              className="font-extrabold text-[22px]"
              onClick={() => applyStyle("heading", "h3")}
            >
              H3
            </button>
            <button
              className="font-extrabold text-[22px]"
              onClick={() => applyStyle("heading", "h4")}
            >
              H4
            </button>
            <button
              className="font-extrabold text-[22px]"
              onClick={() => applyStyle("heading", "h5")}
            >
              H5
            </button>
            <button
              className="font-extrabold text-[22px]"
              onClick={() => applyStyle("heading", "h6")}
            >
              H6
            </button>
            <button
              className="text-[22px]"
              onClick={() => applyStyle("normal")}
            >
              Normal
            </button>
          </div>
          <div className="flex items-center gap-7 w-full border-r-2 border-[black] pr-[10px]">
            <button onClick={() => applyStyle("unlist", "insertUnorderedList")}>
              <svg className="icon text-[34px]">
                <use href="#icon_list"></use>
              </svg>
            </button>
            <button onClick={() => applyStyle("orlist", "insertOrderedList")}>
              <svg className="icon text-[26px]">
                <use href="#icon_order-list"></use>
              </svg>
            </button>
            {/* <button className="text-[22px]" onClick={() => applyStyle("toc")}>
              Add to TOC
            </button> */}
      {/* <button className="text-[22px]" onClick={() => openTableModal()}>
              Table
            </button>
          </div>
          <div
            className="flex items-center gap-4 w-full"
            onClick={() => {
              contentEditableRef.current.focus();
              saveSelection();
              setTimeout(() => {
                openModalFn();
              }, 200);
            }}
          >
            <button>
              <svg className="icon text-[20px]">
                <use href="#icon_insert-img"></use>
              </svg>
            </button>
          </div>
          <div className="flex items-center gap-7 w-full ">
            {isSourceView ? (
              <button className="font-bold" onClick={normalView}>
                SOURCE VIEW
              </button>
            ) : (
              <button className="font-bold" onClick={sourceView}>
                EDITOR VIEW
              </button>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2 bg-[#F9F9F9] py-1 px-1">
          <div className="flex items-center gap-7 w-full pr-[10px]">
            <button onClick={() => applyStyle("align", "left")}>Left</button>
            <button onClick={() => applyStyle("align", "center")}>
              Center
            </button>
            <button onClick={() => applyStyle("align", "right")}>Right</button>
            <button onClick={() => applyStyle("align", "justify")}>
              Justify
            </button>
          </div>
        </div>
        {isSourceView ? (
          <textarea
            ref={textAreaRef}
            contentEditable // Make the div editable
            style={{
              width: "100%",
              height: "72vh",
              border: "1px solid #ccc",
              padding: "10px",
              fontSize: "16px",
            }}
          />
        ) : (
          <>
            <div
              ref={contentEditableRef}
              contentEditable
              style={{
                border: "1px solid #ccc",
                minHeight: "100px",
                padding: "5px",
                fontSize: "16px",
                maxHeight: "72vh",
                overflow: "auto",
                outline: "none", // Remove the default focus outline
                width: "100%",
              }}
              onInput={(e) => handleContentChange(e)}
              className="text-lg text-editor"
              dangerouslySetInnerHTML={{ __html: stringOutput }}
              onFocus={() => {
                contentEditableRef.current.style.border =
                  "2px solid rgb(56, 140, 197)";
              }}
              onBlur={() => {
                contentEditableRef.current.style.border = "1px solid #ccc";
              }}
            />
          </>
        )}
      </div> */}
      <div className="sticky top-[65px] flex items-center gap-2 bg-gray-100 p-2 border-b border-gray-300 rounded-md z-50">
        {/* Formatting Buttons */}
        <div className="flex items-center gap-2 border-r border-gray-400 pr-3">
          {[
            { style: "bold", label: "B", tooltip: "Bold" },
            { style: "italic", label: "I", tooltip: "Italic" },
            { style: "underline", label: "U", tooltip: "Underline" },
            {
              style: "strikeThrough",
              label: <s>S</s>,
              tooltip: "Strikethrough",
            },
          ].map(({ style, label, tooltip }) => (
            <button
              key={style}
              className={`text-[20px] px-3 py-1 rounded-md transition ${
                activeFormats[style] ? "bg-gray-300" : "hover:bg-gray-200"
              }`}
              onClick={() => applyStyle(style, style)}
              data-tooltip-id="my-tooltip"
              data-tooltip-content={tooltip}
              data-tooltip-place="bottom"
            >
              {label}
            </button>
          ))}
        </div>

        {/* Heading Options */}
        <div className="flex items-center gap-2 border-r border-gray-400 pr-3">
          {["H1", "H2", "H3", "H4", "H5", "H6"].map((h) => (
            <button
              key={h}
              // className={`font-extrabold text-[18px] px-3 py-1 rounded-md hover:bg-gray-200 transition`}
              className={`font-extrabold text-[18px] px-3 py-1 rounded-md transition ${
                activeFormats.heading === h
                  ? "bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
              onClick={() => applyStyle("formatBlock", h.toLowerCase())}
              data-tooltip-id="my-tooltip"
              data-tooltip-content={`Heading ${h.replace("H", "")}`}
              data-tooltip-place="bottom"
            >
              {h}
            </button>
          ))}
          <button
            className="text-[18px] px-3 py-1 rounded-md hover:bg-gray-200 transition"
            onClick={() => applyStyle("formatBlock", "p")}
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Paragraph"
            data-tooltip-place="bottom"
          >
            Normal
          </button>
        </div>

        {/* List Options */}
        <div className="flex items-center gap-3 border-r border-gray-400 pr-3">
          {[
            {
              style: "insertUnorderedList",
              icon: "icon_list",
              tooltip: "Unordered List",
            },
            {
              style: "insertOrderedList",
              icon: "icon_order-list",
              tooltip: "Ordered List",
            },
          ].map(({ style, icon, tooltip }) => (
            <button
              key={style}
              // className="p-2 rounded-md hover:bg-gray-200 transition"
              className={`p-2 rounded-md transition ${
                activeFormats[style] ? "bg-gray-300" : "hover:bg-gray-200"
              }`}
              onClick={() => applyStyle(style, style)}
              data-tooltip-id="my-tooltip"
              data-tooltip-content={tooltip}
              data-tooltip-place="bottom"
            >
              <svg className="icon text-[24px]">
                <use href={`#${icon}`}></use>
              </svg>
            </button>
          ))}
        </div>

        {/* Link Button */}
        <div className="">
          <button
            onClick={() => applyStyle("createLink", "")}
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Insert Link"
            data-tooltip-place="bottom"
            ref={linkButtonRef}
            className={`p-2 rounded-md ${
              linkToolbar.show || activeFormats?.link
                ? "bg-gray-300"
                : "hover:bg-gray-200"
            } transition`}
          >
            <svg className="icon text-[22px]">
              <use href="#icon_link"></use>
            </svg>
          </button>
        </div>
        <div
          className="flex items-centerw-full"
          onClick={() => {
            contentEditableRef.current.focus();
            saveSelection();
            setTimeout(() => {
              openModalFn();
            }, 200);
          }}
        >
          <button>
            <svg className="icon text-[20px]">
              <use href="#icon_insert-img"></use>
            </svg>
          </button>
        </div>

        {/* Alignment Options */}
        <div className="flex items-center gap-3">
          {[
            {
              style: "justifyLeft",
              icon: "icon_left",
              tooltip: "Left Align",
              computedStyle: "left",
            },
            {
              style: "justifyCenter",
              icon: "icon_center",
              tooltip: "Center Align",
              computedStyle: "center",
            },
            {
              style: "justifyRight",
              icon: "icon_right",
              tooltip: "Right Align",
              computedStyle: "right",
            },
            {
              style: "justifyFull",
              icon: "icon_justify",
              tooltip: "Justify Text",
              computedStyle: "justify",
            },
          ].map(({ style, icon, tooltip, computedStyle }) => (
            <button
              key={style}
              // className="p-2 rounded-md hover:bg-gray-200 transition"
              className={`p-2 rounded-md transition ${
                activeFormats.alignment === computedStyle
                  ? "bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
              onClick={() => applyStyle(style, style)}
              data-tooltip-id="my-tooltip"
              data-tooltip-content={tooltip}
              data-tooltip-place="bottom"
            >
              <svg className="icon text-[22px]">
                <use href={`#${icon}`}></use>
              </svg>
            </button>
          ))}
        </div>
        <div className="flex items-center w-full ">
          {isSourceView ? (
            <button className="font-bold" onClick={normalView}>
              SOURCE VIEW
            </button>
          ) : (
            <button className="font-bold" onClick={sourceView}>
              EDITOR VIEW
            </button>
          )}
        </div>
      </div>
      {isSourceView ? (
        <textarea
          ref={textAreaRef}
          contentEditable // Make the div editable
          style={{
            width: "100%",
            height: "72vh",
            border: "1px solid #ccc",
            padding: "10px",
            fontSize: "16px",
          }}
        />
      ) : (
        <>
          <div
            ref={contentEditableRef}
            contentEditable
            style={{
              backgroundColor: "#fff",
              minHeight: "400px", // More height like a page
              // maxWidth: "800px", // Prevents stretching too wide
              // margin: "40px auto", // Centers the editor
              padding: "20px",
              fontSize: "16px",
              // lineHeight: "1.6",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Adds a subtle shadow
              outline: "none",
            }}
            onInput={handleContentChange}
            onMouseUp={handleSelectionChange}
            onKeyUp={handleSelectionChange}
            className="text-[#333] mx-0.5 text-editor focus:outline-none"
            dangerouslySetInnerHTML={{ __html: stringOutput }}
            // onFocus={() => {
            //   contentEditableRef.current.style.border =
            //     "2px solid rgb(56, 140, 197)";
            // }}
            // onBlur={() => {
            //   contentEditableRef.current.style.border = "1px solid #ccc";
            // }}
          />
          {linkToolbar.show && (
            <div
              onClick={(e) => console.log(e.target.offsetWidth)}
              className="fixed bg-white shadow-md p-2 border rounded-md flex items-center space-x-2"
              style={{
                position: "fixed",
                top: `${linkToolbar.position.top}px`,
                left: `${linkToolbar.position.left}px`,
                transform: "translateY(0)",
                transition: "top 0.1s ease",
              }}
              ref={toolbarRef}
            >
              {linkToolbar.edit ? (
                // Edit Mode: Show input field and buttons
                <div className="flex items-center space-x-2 w-65">
                  <textarea
                    ref={linkInputRef}
                    type="text"
                    className="border p-1 text-sm rounded w-52"
                    placeholder="Enter URL"
                    value={linkToolbar.value}
                    onChange={(e) =>
                      setLinkToolbar((prev) => ({
                        ...prev,
                        value: e.target.value,
                      }))
                    }
                  />
                  <div className="flex space-x-1">
                    <button
                      className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded-md text-sm flex items-center"
                      onClick={() => {
                        linkToolbar.applyLink(linkToolbar.value);
                      }}
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content="Apply Link"
                      data-tooltip-place="bottom"
                    >
                      <svg className="icon text-[18px]">
                        <use href="#icon_apply"></use>
                      </svg>
                    </button>
                    <button
                      className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded-md text-sm flex items-center"
                      onClick={() => {
                        linkToolbar.removeLink();
                      }}
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content="Remove Link"
                      data-tooltip-place="bottom"
                    >
                      <svg className="icon text-[18px]">
                        <use href="#icon_remove"></use>
                      </svg>
                    </button>
                  </div>
                </div>
              ) : (
                // View Mode: Show link with edit button
                <div className="flex items-center space-x-2 w-65">
                  <a
                    href={linkToolbar.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline text-sm break-all w-52"
                  >
                    {linkToolbar.value}
                  </a>
                  <button
                    className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-1 rounded-md text-sm flex items-center"
                    onClick={() => {
                      setLinkToolbar((prev) => ({ ...prev, edit: true }));
                    }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Edit Link"
                    data-tooltip-place="bottom"
                  >
                    <svg className="icon text-[18px]">
                      <use href="#icon_edit"></use>
                    </svg>
                  </button>
                </div>
              )}
            </div>
          )}
        </>
      )}
      <Modal
        root={documentBodyRef?.current}
        dismissible
        show={openModal === "dismissible"}
        size="md"
        onClose={() => setopenModal(undefined)}
        zIndex="1000"
        centered
      >
        <Modal.Header className="capitalize py-2">
          <h6 className="font-bold text-[24px]">Insert/Edit Image</h6>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="pb-3 pt-4">
            <label htmlFor="file">Image url</label>
            <input
              type="text"
              className="mt-1 w-full rounded-full px-3 py-2 bg-[#FAFBFC] border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block sm:text-sm focus:ring-1"
              placeholder="Image url"
              value={imageUrl}
              onChange={(e) => {
                setimageUrl(e.target.value);
                imageRef.current.value = null;
                if (rawFile) {
                  setrawFile(null);
                  setpreviewUrl(null);
                  imageRef.current.value = null;
                  setdisplayChooseFile(false);
                  setTimeout(() => {
                    setdisplayChooseFile(true);
                  }, 10);
                }
              }}
            />
          </div>
          <div className="text-center pb-3">or</div>
          <div className="pb-3">
            <label htmlFor="file">Upload From Local</label>
            <input
              type="file"
              id="uploaadfile"
              name="file"
              ref={imageRef}
              className="mt-1 w-full rounded-full bg-[#FAFBFC] border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block sm:text-sm focus:ring-1"
              placeholder="Upload From Local"
              accept="image/*"
              onChange={(e) => {
                setimageUrl("");
                setrawFile(e.target.files[0]);
              }}
            />
          </div>

          <div className="pb-3">
            <label htmlFor="file">ALT Text</label>
            <input
              type="text"
              value={alttext}
              className="mt-1 w-full rounded-full bg-[#FAFBFC] border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block sm:text-sm focus:ring-1"
              placeholder="Enter alt text"
              onChange={(e) => {
                setalttext(e.target.value);
              }}
            />
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="file">Width (in px)</label>
              <input
                type="text"
                className="mt-1 w-full rounded-full px-3 py-2 bg-[#FAFBFC] border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block sm:text-sm focus:ring-1"
                placeholder="Width"
                value={imageWH?.width}
                onChange={(e) =>
                  setimageWH({
                    ...imageWH,
                    width: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label htmlFor="file">Height (in px)</label>
              <input
                type="text"
                className="mt-1 w-full rounded-full px-3 py-2 bg-[#FAFBFC] border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block sm:text-sm focus:ring-1"
                placeholder="Height"
                value={imageWH?.height}
                onChange={(e) =>
                  setimageWH({
                    ...imageWH,
                    height: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="pt-4 flex justify-end">
            <button
              type="button"
              className="flex w-[130px] items-center text-center justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#ed1512] text-white  hover:from-[#9d3742] hover:to-[#1A71A7] me-6"
              onClick={() => {
                contentEditableRef.current.focus();
                setopenModal(undefined);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="flex w-[130px] items-center text-center justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white  hover:from-[#9D3784] hover:to-[#1A71A7]"
              onClick={() => {
                if (imageRef.current) {
                  imageRef.current.value = null; // Clear the input field
                }
                setimageUrl("");
                setpreviewUrl(null);
                setrawFile(null);
                restoreSelection(); // Restore the saved selection
                contentEditableRef.current.focus();
                applyStyle("image");
              }}
              disabled={imageUrl == "" && !previewUrl}
            >
              Add
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Tooltip
        id="my-tooltip"
        place="bottom"
        delayShow={100}
        className="react-tooltip"
      />
      {/*{showTableModal && (
        <div className="table-modal">
          <label>
            Rows:
            <input
              type="number"
              value={tableRows}
              onChange={(e) => setTableRows(e.target.value)}
            />
          </label>
          <label>
            Columns:
            <input
              type="number"
              value={tableColumns}
              onChange={(e) => setTableColumns(e.target.value)}
            />
          </label>
          <button onClick={insertTable}>Insert Table</button>
          <button onClick={closeTableModal}>Cancel</button>
        </div>
      )} */}
    </>
  );
};

export default TextEditor;
